/* eslint-disable vue/no-reserved-keys */
<template lang="html">
  <div class="content-item" @click="goRedirectDetails">
    <div class="content-item-left">
      <div class="year">{{getPublishTime[2]}}</div>
      <div class="mouth">{{getPublishTime[1]}}月</div>
    </div>
    <div class="content-item-body">
      <span class="desc" v-html="getContent"></span>
      <div class="content-item-imgs">
        <img v-if="getImages.length === 1" class="maxImg" @click.stop="changeModel(0)"
          v-lazy="`${getImages[0].url}?x-oss-process=image/resize,m_fill,w_392,h_392`" />
        <img v-else v-for="(img, index) of getImages" class="singal"  @click.stop="changeModel(index)" :key="img.sort"
          v-lazy="`${img.url}?x-oss-process=image/resize,m_fill,w_184,h_184`" />
      </div>
      <div class="content-bottom">
        <div class="content-bottom-left">
          <h5>{{getShowTime}}</h5>
          <span v-if="(users && users === user)" class="delete" @click.stop="deleteMessage">删除</span>
        </div>

        <div class="menus">
          <ThumbUpItem @click="goCreate">
            <img  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/message-grey.svg" />
            <span>{{getCommentCount}}</span>
          </ThumbUpItem>
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
        </div>
      </div>
    </div>
    <ImgModel :imgs="modelSrc" :initialIndex="initialIndex" @click.native="changeModel" v-if="modelShow"/>
  </div>
</template>
<script>
import { post, _delete } from '../utils/request'
import { get, set, remove } from '../utils/token'
import { getBeforeTimeStr } from '../utils/date'
import ImgModel from '../components/ImgFile'
import ThumbUpItem from '../components/thunmbUpItem'
import { Toast } from 'vant'
export default {
  components: {
    ImgModel,
    ThumbUpItem
  },
  props: {
    id: {
      // type: Number,
      default: 0
    },
    circle: {
      type: Object,
      default: () => {
        return {
          commentCount: 0,
          content: '',
          crateTime: '',
          curriculum: null,
          id: 0,
          images: [],
          isRecommend: false,
          isUp: false,
          upCount: 0,
          downCount: 0
        }
      }
    },
    diss: {
      type: Object,
      default: () => {
        return {
          commentCount: 0,
          content: '',
          crateTime: '',
          curriculum: null,
          id: 0,
          images: [],
          isRecommend: false,
          isUp: false,
          upCount: 0,
          downCount: 0,
          isActual: false,
          is_delete: false,
          is_show: true,
          tags: []
        }
      }
    },
    user: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      modelSrc: [],
      modelShow: false,
      initialIndex: 0,
      users: get('user')
    }
  },
  activated () {
    this.scrollLocation()
  },
  // mounted () {
  //   this.scrollLocation()
  // },
  methods: {
    deleteMessage () {
      const item = this.getItem
      const promise = _delete({
        url: `/circle/circle?id=${item.id}`
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', item.id)
        Toast.success(message)
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = get('scrollDynamic')
        if (scrollTop && this.$refs.dynamic) {
          this.$refs.dynamic.scrollTop = scrollTop
          remove('scrollDynamic')
        }
      })
    },
    changeModel (index = 0) {
      this.initialIndex = 0
      if (index) {
        this.initialIndex = index
      }
      this.modelShow = !this.modelShow
      if (this.modelShow) {
        this.modelSrc = this.getImages
      }
      // if (e) {
      //   e.preventDefault()
      //   e.stopPropagation()
      // }
    },
    goCreate () {
      const dynamic = this.$parent.$refs.dynamic
      if (dynamic) {
        set('scrollDynamic', this.$parent.$refs.dynamic.scrollTop)
      }
      const { circle, diss } = this
      const item = circle || diss
      if (circle) {
        this.$router.push(`/exerland/create?circleId=${item.id}`)
        return
      }
      if (diss) {
        this.$router.push(`/exerland/makeComplaintsCreate?dissId=${item.id}`)
      }
    },
    thumbsUp (callback) {
      const { circle, diss } = this
      const item = circle || diss
      let url = '/circle'
      if (diss) {
        url = '/diss'
      }
      const promsie = post({
        url: `${url}/isUp/${item.id}/${get('user').id}`,
        data: {
          isUp: !item.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          if (callback) {
            callback()
          }
          this.$emit('thumbsUp')
        }
      })
    },
    goRedirectDetails () {
      const { circle, diss } = this
      const item = circle || diss
      if (circle) {
        this.$router.push(`/exerland/dynamicTetail/${item.id}`)
        return
      }
      if (diss) {
        this.$router.push(`/exerland/makeComplaintsDetails/${item.id}`)
      }
    },
    goDetails () {
      const { circle, diss } = this
      const item = circle || diss
      if (circle) {
        if (item.commentCount) {
          this.$router.push(`/exerland/dynamicTetail/${item.id}`)
        } else {
          this.$router.push(`/exerland/create?circleId=${item.id}`)
        }
        return
      }
      if (diss) {
        if (item.commentCount) {
          this.$router.push(`/exerland/makeComplaintsDetails/${item.id}`)
        } else {
          this.$router.push(`/exerland/makeComplaintsCreate?dissId=${item.id}`)
        }
      }
    }
  },
  computed: {
    getItem () {
      const { circle, diss } = this
      return circle || diss
    },
    getThumbUp () {
      const item = this.getItem
      return {
        isUp: item.isUp,
        // url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        // url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        upCount: item.upCount,
        label: ''
      }
    },
    getImages () {
      const item = this.getItem
      return item.images
    },
    getShowTime () {
      const item = this.getItem
      return getBeforeTimeStr(item.crateTime)
    },
    getCommentCount () {
      const item = this.getItem
      return item.commentCount || ''
    },
    getContent () {
      const item = this.getItem
      return item.content || ''
    },
    // 计算出发表的时间
    getPublishTime () {
      const time = this.circle.crateTime
      const timeArr = time.split(' ')[0].split('-')
      timeArr[1] = timeArr[1].replace(/\b(0+)/gi, '')
      return timeArr
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .customClass {
  width: 300px;
}
.content-item {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .content-item-left {
    .year {
      font-size:20px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(51,51,51,1);
      line-height:21px;
    }
    .mouth {
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:17px;
    }
  }
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    h2 {
      font-size: 16px;
      font-family: SFProText-Semibold, SFProText;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;
      margin-bottom: 1px;
    }
    h5 {
      font-size: 14px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 13px;
    }
    .content-item-body-header {
      display: flex;
      justify-content: space-between;
      .tag {
        box-sizing: border-box;
        font-size:11px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(24,204,159,1);
        line-height: 20px;
        height:20px;
        background:rgba(236,253,249,1);
        border-radius:4px;
        box-sizing: border-box;
        display: inline-block;
        padding: 0 12px;
      }
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2vw;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .content-item-imgs {
      img {
        // max-width: 92px;
        // max-height: 92px;
        margin-right: 4px;
      }
      .maxImg {
        max-width: 196px;
        max-height: 196px;
      }
      .singal {
        max-width: 92px;
        max-height: 92px;
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      justify-content: space-between;
      align-items: center;
      .content-bottom-left {
        display: flex;
        .delete {
          display: block;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,107,148,1);
          line-height:13px;
          margin-left: 16px;
        }
      }
      .menus {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
</style>
